<template>
  <ul class="list-group">
    <li class="list-group-item" v-for="b in sorted_bids" :key="b">
      {{ b.amount }}
    </li>
  </ul>
</template>
<script setup>
import supabase from "@/supabase/config";
import { onMounted, ref, defineProps, computed } from "vue";
import { useStore } from "@/store/index";
const store = useStore();
const props = defineProps(["player_id"]);
const player_bids = ref([]);
onMounted(() => {
  setTimeout(() => {
    fetchBids();
  }, 500);
});
const fetchBids = async () => {
  let { data: bids, error } = await supabase
    .from("bids")
    .select("*")
    .eq("player_id", props.player_id);
  player_bids.value = bids;
};
const sorted_bids = computed(() => {
  var arr = [];
  player_bids.value.forEach((b) => {
    arr.push(b);
  });
  var sorted_arr = [];
  sorted_arr = [...arr].sort((a, b) => b.amount - a.amount);
  //last_bid_amount.value = sorted_arr[0].amount + auction.bid_increment;
  return sorted_arr;
});
</script>
